exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-templates-about-page-template-tsx": () => import("./../../../src/templates/aboutPage.template.tsx" /* webpackChunkName: "component---src-templates-about-page-template-tsx" */),
  "component---src-templates-landing-page-template-tsx": () => import("./../../../src/templates/landingPage.template.tsx" /* webpackChunkName: "component---src-templates-landing-page-template-tsx" */)
}

